import dateFormat from 'ourwill-feutil/common/dateFormat';
import env from '@/services/config';

export const timeFilterGlobal = (value, fmt = 'YYYY-MM-DD HH:mm:ss') => {
	// debugger;
	if (value) {
		return dateFormat(value, fmt);
	} else {
		return value;
	}
};

export const bytesToSize = function bytesToSize(
	size,
	{ emptyValuePlaceholder = '', storageBase = 1024 } = { emptyValuePlaceholder: '', storageBase: 1024 },
) {
	if (!size) {
		return emptyValuePlaceholder;
	}

	if (size < storageBase) {
		return size + 'B';
	}
	if (size < Math.pow(storageBase, 2)) {
		return (size / storageBase).toFixed(2) + 'KB';
	} //kb
	if (size < Math.pow(storageBase, 3)) {
		return (size / Math.pow(storageBase, 2)).toFixed(2) + 'MB';
	} //M
	if (size < Math.pow(storageBase, 4)) {
		return (size / Math.pow(storageBase, 3)).toFixed(2) + 'GB';
	} //G
	return (size / Math.pow(storageBase, 4)).toFixed(2) + 'TB'; //T
};

export const durationFilter = (val) => {
	let second, min, hour;
	hour = Math.floor(val / (60 * 60 * 24)) * 24 + (Math.floor(val / (60 * 60)) % 24);
	min = Math.floor(val / 60) % 60;
	second = Math.ceil(val % 60);
	return (hour ? hour + '小时' : '') + (min ? min + '分钟' : '') + (second ? second + '秒' : '');
};

export const globalAvatarUrlFilter = (info) => {
	if (info.avatarUrl) {
		// 有头像
		return info.avatarUrl;
	} else if (info.userId) {
		// 没头像 有用户id
		if (info.userId > 0) {
			return `https://avatar.cdinmu.com/srv/cache/head/${info.userId}.jpg`;
		} else {
			return `https://avatar.cdinmu.com/srv/cache/head1/${Math.abs(info.userId)}.jpg`;
		}
	} else if (info.content === undefined && !info.userId && info.id) {
		// 没头像 没用户id 没有评论内容 有id （进入直播间的userid 其实是id）
		// 进入直播间
		if (info.id > 0) {
			return `https://avatar.cdinmu.com/srv/cache/head/${info.id}.jpg`;
		} else {
			return `https://avatar.cdinmu.com/srv/cache/head1/${Math.abs(info.id)}.jpg`;
		}
	} else {
		return 'https://s.tuwenzhibo.com/app/static/69user.png';
	}
};
